import styled from "styled-components";

export const TodoList = styled.div`
  width: 100%;
  min-height: 90vh;
  margin-bottom: 100px;
  .header {
    color: #076822;
    font-weight: 400;
  }
  .todos {
    padding: 10px;
  }
  .todo {
    border: 1px solid #ccc;
    margin: 10px;
    position: relative;
    padding: 0 20px 10px 20px;
    background-color: #fff;
    min-height: 100px;
    .float-right button {
      background-color: #fff;
      color: #06a82a;
      font-weight: 600;
      margin-right: -10px;
      border: none;
    }
    .float-right button:hover {
      font-weight: 600;
      color: #000;
    }
    h5 {
      font-weight: 600;
      padding: 10px 0;
    }
    .delete-btn {
      position: absolute;
      right: 0;
      width: 25px;
      background-color: white;
      border: 1px solid red;
    }
    .add-btn {
      position: absolute;
      right: 28px;
      background-color: #06a82a;
      border: 1px solid #06a82a;
      color: #fff;
      width: 100px;
    }
    .create-task {
      border: 1px solid #ccc;
      background-color: #fff;
      margin-top: 1px;
      border-radius: 3px;
      padding: 1px;
      input {
        width: 95%;
        border: none;
        padding: 5px;
        outline: none;
      }
      button {
        float: right;
        padding: 5px;
        height: 100%;
        border: none;
        border-left: 1px solid #ccc;
      }
    }
  }
`;

export const ModalWrapper = styled.div`
  display: inline-flex;
  margin-top: 150px;
  justify-content: center;
  align-items: center;
  z-index: 20;
  position: fixed;

  top: 0;
  right: 0;
  left: 0;
  @media (max-width: 380px) {
    width: 375px;
    margin-top: 450px;
  }

  form {
    margin-top: -100px;
    background: black;
    color: orange;
    font-family: system-ui;
    border-radius: 3px;
    width: 500px;
    padding: 30px;
    z-index: 20;
    box-shadow: 0 0 10px orange;
  }
`;
